<template>
  <teleport to="body">
    <div class="modal-container" :style="{ 'z-index': zIndex + 1 }" v-if="isVisible">
      <div class="modal info-popup" v-bind="$attrs" ref="modalBlock">
        <div class="modal-title" ref="modalTitle">
          <div class="title-block">
            <div class="title">{{ trans("modals.auth.title") }}</div>
          </div>
          <div class="modal__close" @click="close"></div>
        </div>
        <div class="modal-content">
          <div class="description">{{ props.message }}</div>
          <div class="actions">
            <a href="/login" class="btn btn-blue">{{ trans("modals.auth.login_btn") }}</a>
            <a href="/register" class="btn btn-blue">{{ trans("modals.auth.sign_up_btn") }}</a>
            <a href="#" @click.prevent="close" class="btn btn-blue-outline">{{ trans("modals.auth.not_now_btn") }}</a>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal-overlay background-fill"
      :style="{ 'z-index': zIndex }"
      v-if="isVisible"
      @click="isVisible = false"></div>
  </teleport>
</template>

<script setup lang="ts">
  import { onBeforeUnmount, onMounted, ref, watch } from "vue";
  import { trans } from "@/utils/trans";

  const props = defineProps<{
    message: string;
  }>();

  const isVisible = ref(false);
  const zIndex = ref(0);

  onMounted(() => {
    document.addEventListener("keydown", closeByEscapeKey);
  });

  onBeforeUnmount(() => {
    document.removeEventListener("keydown", closeByEscapeKey);
  });

  watch(isVisible, (nv) => {
    zIndex.value = nv ? 14 : 0;
  });

  const open = () => {
    isVisible.value = true;
  };

  const close = () => {
    isVisible.value = false;
  };

  const closeByEscapeKey = (event) => {
    if (event.keyCode === 27) {
      close();
    }
  };

  defineExpose({
    open,
    close
  });
</script>
